import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height", "viewBox"]
const _hoisted_2 = { "clip-path": "url(#clip0_138_5357)" }
const _hoisted_3 = ["fill"]
const _hoisted_4 = ["fill"]
const _hoisted_5 = ["fill"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_138_5357" }, [
    /*#__PURE__*/_createElementVNode("rect", {
      width: "20",
      height: "20",
      fill: "white"
    })
  ])
], -1)

import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'eyeSearchIcon',
  props: {
  color: {
    type: String as PropType<string>,
    default: "#211F58",
  },
  size: {
    type: Number as PropType<number>,
    default: 20,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    width: __props.size,
    height: __props.size,
    viewBox: `0 0 ${__props.size} ${__props.size}`,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    class: "!tw-w-[19px] !tw-h-[19px]"
  }, [
    _createElementVNode("g", _hoisted_2, [
      _createElementVNode("path", {
        d: "M10 7.0836C10.6904 7.0836 11.25 6.52395 11.25 5.8336C11.25 5.14324 10.6904 4.5836 10 4.5836C9.30964 4.5836 8.75 5.14324 8.75 5.8336C8.75 6.52395 9.30964 7.0836 10 7.0836Z",
        fill: __props.color
      }, null, 8, _hoisted_3),
      _createElementVNode("path", {
        d: "M10.0003 9.25833C10.0064 9.24983 10.0097 9.23963 10.0097 9.22917C10.0097 9.2187 10.0064 9.2085 10.0003 9.2C10.0031 9.18907 10.0031 9.1776 10.0003 9.16667C9.25846 9.16922 8.53701 8.92426 7.95012 8.47057C7.36323 8.01688 6.94444 7.38038 6.76007 6.66185C6.57569 5.94333 6.63626 5.18383 6.93218 4.50361C7.22811 3.82338 7.74248 3.26131 8.39385 2.90637C9.04523 2.55142 9.79639 2.4239 10.5284 2.54399C11.2604 2.66407 11.9315 3.02491 12.4353 3.56936C12.9391 4.11381 13.247 4.81076 13.3101 5.54988C13.3731 6.289 13.1879 7.02804 12.7836 7.65C12.761 7.68318 12.749 7.72237 12.749 7.7625C12.749 7.80263 12.761 7.84182 12.7836 7.875C12.8035 7.90897 12.8334 7.93599 12.8691 7.95239C12.9049 7.96879 12.9449 7.97377 12.9836 7.96667C14.4169 7.7782 15.869 8.12862 17.0586 8.95C17.0943 8.974 17.1364 8.98682 17.1794 8.98682C17.2225 8.98682 17.2645 8.974 17.3003 8.95C18.0895 8.36566 18.8307 7.71915 19.5169 7.01667C19.6731 6.86173 19.7971 6.67739 19.8818 6.47429C19.9664 6.2712 20.0099 6.05335 20.0099 5.83333C20.0099 5.61331 19.9664 5.39547 19.8818 5.19237C19.7971 4.98927 19.6731 4.80494 19.5169 4.65C17.3336 2.39167 13.7336 0 10.1253 0H9.87527C6.2586 0 2.6586 2.39167 0.483598 4.65C0.327384 4.80494 0.203393 4.98927 0.118779 5.19237C0.0341643 5.39547 -0.00939941 5.61331 -0.00939941 5.83333C-0.00939941 6.05335 0.0341643 6.2712 0.118779 6.47429C0.203393 6.67739 0.327384 6.86173 0.483598 7.01667C2.55994 9.23199 5.23971 10.7906 8.19193 11.5C8.23815 11.509 8.28605 11.5014 8.32721 11.4785C8.36837 11.4556 8.40014 11.419 8.41693 11.375C8.77883 10.5594 9.32004 9.83585 10.0003 9.25833Z",
        fill: __props.color
      }, null, 8, _hoisted_4),
      _createElementVNode("path", {
        d: "M19.6916 18.2247L17.8 16.3247C17.7716 16.2893 17.7561 16.2452 17.7561 16.1997C17.7561 16.1543 17.7716 16.1102 17.8 16.0747C18.2057 15.3763 18.4185 14.5825 18.4166 13.7747C18.4166 12.8633 18.1463 11.9723 17.64 11.2145C17.1336 10.4567 16.4139 9.86599 15.5718 9.5172C14.7298 9.1684 13.8032 9.07714 12.9092 9.25495C12.0153 9.43277 11.1942 9.87167 10.5497 10.5162C9.90522 11.1606 9.46631 11.9818 9.2885 12.8757C9.11069 13.7696 9.20195 14.6962 9.55074 15.5383C9.89954 16.3803 10.4902 17.1001 11.248 17.6064C12.0059 18.1128 12.8968 18.3831 13.8083 18.3831C14.6135 18.3859 15.4048 18.1729 16.1 17.7664C16.1373 17.7387 16.1826 17.7237 16.2291 17.7237C16.2756 17.7237 16.3209 17.7387 16.3583 17.7664L18.2583 19.6581C18.3538 19.7558 18.4678 19.8335 18.5938 19.8866C18.7197 19.9396 18.855 19.9669 18.9916 19.9669C19.1283 19.9669 19.2635 19.9396 19.3895 19.8866C19.5154 19.8335 19.6295 19.7558 19.725 19.6581C19.9059 19.4613 20.0035 19.202 19.9973 18.9347C19.9911 18.6674 19.8815 18.4129 19.6916 18.2247ZM13.775 16.7164C13.1931 16.7164 12.6244 16.5439 12.1407 16.2206C11.6569 15.8974 11.2799 15.438 11.0572 14.9005C10.8346 14.3629 10.7763 13.7715 10.8898 13.2008C11.0033 12.6302 11.2835 12.1061 11.6949 11.6947C12.1063 11.2833 12.6304 11.0031 13.2011 10.8896C13.7717 10.7761 14.3632 10.8343 14.9007 11.057C15.4382 11.2796 15.8976 11.6567 16.2209 12.1404C16.5441 12.6242 16.7166 13.1929 16.7166 13.7747C16.7144 14.5542 16.4038 15.3012 15.8526 15.8524C15.3014 16.4036 14.5545 16.7142 13.775 16.7164Z",
        fill: __props.color
      }, null, 8, _hoisted_5)
    ]),
    _hoisted_6
  ], 8, _hoisted_1))
}
}

})